import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { FormStatusesCreate, FormStatusesDelete, FormStatusesRefresh, FormStatusesUpdate } from './form-status.action';
import { ChecklistBuilderService } from 'src/app/components/checklists/checklist-builder/checklist-builder.service';
import { FormStatus } from 'src/app/services/forms/form-status';


export class FormStatusesStateModel {
  data: FormStatus[] = [];
}

@State<FormStatusesStateModel>({
  name: 'FormStatuses',
  defaults: {
    data: []
  }
})
@Injectable()
export class FormStatusesState extends BaseState {
  constructor(
    protected override injector: Injector,
    private _service: ChecklistBuilderService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: FormStatusesStateModel) {
    return state.data;
  }

  @Action(FormStatusesRefresh)
  refresh({ patchState }: StateContext<FormStatusesStateModel>) {
    this._service.getFormStatuses().toPromise().then(
      data => patchState({ data }),
      error => console.error(error)
    );
  }

  @Action(FormStatusesCreate)
  create({ getState, patchState }: StateContext<FormStatusesStateModel>, { item }: FormStatusesCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);
    if (index >= 0) {
      state.data.splice(index, 1);
    }
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(FormStatusesUpdate)
  update({ getState, patchState }: StateContext<FormStatusesStateModel>, { id, item }: FormStatusesUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(FormStatusesDelete)
  delete({ getState, patchState }: StateContext<FormStatusesStateModel>, { id }: FormStatusesDelete) {
    patchState({
      data: getState().data.filter(x => x.id !== id)
    });
  }

}
